import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom'
import PositionsTable from './positions/PositionTable.js';
import PositionsChart from './positions/PositionsChart.js';
import DailyBalanceChart from './plan/DailyBalanceChart.js'
import TradeInstructions from './trades/TradeInstructions.js'
import RecentReturns from './plan/RecentReturns.js'
import StickySettings from './helpers/StickySettings.js';
import ActiveTrades from './trades/ActiveTrades';
import DailyProfitChart from './plan/DailyProfitChart.js';
import Drawer from '@mui/material/Drawer';
import CompletedTrades from './trades/CompletedTrades.js';
import ActiveBonusTrades from './trades/ActiveBonusTrades.js';
import LaunchIcon from '@mui/icons-material/Launch';

function Overview(props) {

    const [positions, setPositions] = useState([]);
    const [previousPositions, setPreviousPositions] = useState([]);
    const [activeBonusTrades, setActiveBonusTrades] = useState([]);
    const [performanceResults, setPerformanceResults] = useState({});
    const [chartData, setChartData] = useState([]);
    const timerRef = useRef(null);
    const [autoRefresh, setAutoRefresh] = useState(StickySettings.getBool("autoRefreshOverview", false));
    const [indexQuotes, setIndexQuotes] = useState([]);
    const [isActiveTradesOpen, setIsActiveTradesOpen] = useState(false);
    const [isCompletedTradesOpen, setIsCompletedTradesOpen] = useState(false);

    useEffect(() => {
        (async function () {

            const loadPerformanceResults = async () => {
                console.log("Loading performance results for plan " + props.planId);
                setChartData([])
                setPerformanceResults({})
                const url = `/api/lastBacktestResults?planId=` + props.planId + "&liveTradesOnly=1";
                let text = await (await fetch(url)).json();
                console.log("lastBacktest", text);

                const tempChartData = [];
                text.dailyResults.forEach(day => tempChartData.push([new Date(day.date), day.total, day.baseline]))
                setChartData(tempChartData)
                setPerformanceResults(text);
            }

            const loadPositions = async () => {
                console.log("Loading positions...");
                setPositions([])
                const posRes = await fetch(`/api/positions?planId=` + props.planId)
                const pos = await posRes.json();
                console.log("positions", pos);
                setPositions(pos);
                return pos;
            }

            const loadIndexQuotes = async () => {
                console.log("Loading index quotes...");
                const quoteText = await fetch(`/api/quote?symbols=QQQ,SPY`)
                const quotes = await quoteText.json();
                setIndexQuotes(quotes);
                return quotes;
            }

            const loadPreviousDayPositions = async () => {
                console.log("Loading prev positions...");
                setPreviousPositions([])
                const pos = await (await fetch(`/api/previousPositions?planId=` + props.planId)).json();
                console.log("previous positions", pos);
                setPreviousPositions(pos);
            }

            async function loadActiveBonusTrades() {
                let url = `/api/activeUserTrades?planId=` + 108 + `&userId=` + props.userId + `&accountId=0`
                let text = await (await (fetch(url))).json()
                console.log("active bonus trades", text);
                setActiveBonusTrades(text);
            }


            loadPerformanceResults();
            await loadPositions();
            await loadPreviousDayPositions();
            await loadIndexQuotes();
            await loadActiveBonusTrades();

            if (timerRef.current) clearInterval(timerRef.current);
            const id = setInterval(async () => {
                let shouldRefresh = StickySettings.getBool("autoRefreshOverview", false);
                if (shouldRefresh) {
                    console.log("Auto refreshing positions")
                    loadPositions();
                    loadPreviousDayPositions();
                    loadIndexQuotes();
                } else {
                    console.log("Skipping auto refresh")
                }
            }, 60000);
            timerRef.current = id;
        })();
    }, [props.planId, props.userId]);

    function toggleAutoRefresh() {
        StickySettings.setBool("autoRefreshOverview", !autoRefresh);
        setAutoRefresh(!autoRefresh);
    }

    let completedTradesStartDate = new Date()
    completedTradesStartDate.setDate(new Date().getDate() - 1);

    return (
        <>
            <div>
                <h3>Most Recent Trades <Link to="/trades/history">(See Trade Details)</Link> <Link onClick={() => setIsCompletedTradesOpen(true)}><LaunchIcon fontSize='small' /></Link></h3>
                <TradeInstructions accountId={props.accountId} isOptions={props.isOptions} planId={props.planId} accountValue={props.accountValue} userId={props.userId} mobileView={props.mobileView} role={props.role}
                    brokerage={props.brokerage}
                    brokerageHref={props.brokerageHref}
                    brokerageAuthenticated={props.brokerageAuthenticated}
                />

                <hr></hr>
                <div className="sameline">
                    <h3>Current Positions <Link to="/trades/active">(See Active Trades)</Link>
                        &nbsp;<Link onClick={() => setIsActiveTradesOpen(true)}><LaunchIcon fontSize='small' /></Link>
                    </h3>
                </div>

                <input type="checkbox" checked={autoRefresh} onChange={(e) => toggleAutoRefresh()} /> Auto Refresh
                {props.isOptions ?
                    <ActiveTrades hideCharts={true} onlyShowUserTrades={true} userId={props.userId} accountId={props.accountId} planId={props.planId} mobileView={props.mobileView} onAlgoSelected={props.onAlgoSelected} accountValue={props.accountValue} role={props.role} />
                    :
                    <>
                        <PositionsTable planId={props.planId} accountValue={props.accountValue} positions={positions} previousPositions={previousPositions} mobileView={props.mobileView} indexQuotes={indexQuotes} role={props.role} />
                        <PositionsChart planId={props.planId} positions={positions} />
                    </>
                }

                <Drawer
                    anchor={'left'}
                    open={isActiveTradesOpen}
                    onClose={() => setIsActiveTradesOpen(false)}
                >
                    <div style={{ width: 500, padding: '10px' }}>
                        <center><b><Link onClick={() => setIsActiveTradesOpen(false)}>Close</Link></b></center>
                        <br></br>
                        <h4>Active Trades</h4>
                        <ActiveTrades hideCharts={true} onlyShowUserTrades={false} userId={props.userId} accountId={props.accountId} planId={props.planId} mobileView={true} accountValue={props.accountValue} role={props.role} />
                    </div>
                </Drawer >

                <Drawer
                    anchor={'left'}
                    open={isCompletedTradesOpen}
                    onClose={() => setIsCompletedTradesOpen(false)}
                >
                    <div style={{ width: 500, padding: '10px' }}>
                        <center><b><Link onClick={() => setIsCompletedTradesOpen(false)}>Close</Link></b></center>
                        <br></br>
                        <h4>Completed Trades since {completedTradesStartDate.toLocaleDateString()}</h4>
                        <CompletedTrades startDate={completedTradesStartDate} hideDateSelector={true} hideCharts={true} hideMonthlyStats={true} userId={props.userId} accountId={props.accountId} planId={props.planId} mobileView={true} accountValue={props.accountValue} />
                    </div>
                </Drawer >

                {activeBonusTrades && activeBonusTrades.length > 0 ?
                    <>
                        <hr></hr>
                        <div className='sameline'>
                            <h3>Active Bonus Trades&nbsp;<Link to="/trades/bonus">(See Details)</Link></h3>
                        </div>

                        <ActiveBonusTrades hideCharts={true} onlyShowUserTrades={true} planId={108} userId={props.userId} accountId={props.accountId} mobileView={props.mobileView} onAlgoSelected={props.onAlgoSelected} accountValue={props.accountValue} brokerage={null} role={props.role} />
                    </>
                    : null}

                <hr></hr>
                <h3>Performance <Link to={"/planRecap"}>(See YTD Summary)</Link></h3>
                <RecentReturns accountStartDate={props.accountStartDate} backtestResults={performanceResults} accountValue={props.accountValue} mobileView={props.mobileView}></RecentReturns>

                <hr></hr>
                <br></br>
                <h3>Daily Performance</h3>
                <DailyProfitChart planId={props.planId} days={20} backtestResults={performanceResults} mobileView={props.mobileView} />
                <br></br>

                <hr></hr>
                <br></br>
                <h3>Balance History <Link to={"/detailedPerformance"}>(See Detailed Performance)</Link></h3>
                <DailyBalanceChart defaultToYtd={true} startDate={props.accountStartDate} defaultToSyncValues={true} backtestResults={performanceResults} chartData={chartData} hideAllocationChart={false} hideChartSummary={true}></DailyBalanceChart>

                <br></br>


            </div >
        </>
    );
}

export default Overview; 